import { LAYOUT_ALGORITHM } from "Common/dictionaries/layoutAlgorithm";
export default (graphComponentRef, layoutAlgorithmRef) => {
    if (graphComponentRef.current) {
        const inputMode = graphComponentRef.current.inputMode;
        if (inputMode === null || inputMode === void 0 ? void 0 : inputMode.orthogonalEdgeEditingContext)
            inputMode.orthogonalEdgeEditingContext.enabled =
                layoutAlgorithmRef.current === LAYOUT_ALGORITHM.HIERARCHIC ||
                    layoutAlgorithmRef.current === LAYOUT_ALGORITHM.ORTHOGONAL ||
                    layoutAlgorithmRef.current === LAYOUT_ALGORITHM.TREE;
    }
};
